import React from 'react';
import { notification, Button } from 'antd';
import { AlertOutlined } from '@ant-design/icons';
import { causeLabel, clientLabel, integrationLabel } from './incidentConstants';

// Más que el aviso de chat (6 s): un incidente es algo que alguien debe atender.
// antd lo pausa mientras el cursor está encima.
export const NEW_INCIDENT_TOAST_SECONDS = 10;
export const NEW_INCIDENT_TOAST_KEY = 'new-incidents';
/** Cuántos incidentes se listan en la tarjeta; el resto va como «y N más». */
export const MAX_LISTED = 3;

const describe = (incident) =>
  `${integrationLabel(incident.integration)} · ${causeLabel(incident.cause)}`;

/**
 * Aviso de incidente nuevo en el centro de incidentes. Con uno, dice qué integración
 * falló, la causa y el cliente; con varios (llegaron en el mismo ciclo), cuántos son
 * y los primeros. Al hacer clic abre la pantalla de incidentes.
 *
 * Usa una sola clave: si llega otro aviso mientras el anterior sigue en pantalla, lo
 * reemplaza en vez de apilar tarjetas.
 */
export const showNewIncidentsToast = ({ incidents = [], onOpen }) => {
  if (!incidents.length) return;
  const open = () => {
    notification.destroy(NEW_INCIDENT_TOAST_KEY);
    onOpen();
  };
  const listed = incidents.slice(0, MAX_LISTED);
  const hidden = incidents.length - listed.length;

  notification.open({
    key: NEW_INCIDENT_TOAST_KEY,
    icon: <AlertOutlined style={{ color: '#cf1322' }} />,
    message: incidents.length === 1 ? 'Nuevo incidente' : `${incidents.length} incidentes nuevos`,
    description: (
      <div>
        {listed.map((incident) => (
          <div key={incident.id} style={{ marginBottom: 6 }}>
            <div style={{ fontWeight: 600, color: '#1c1917' }}>{describe(incident)}</div>
            <div style={{ color: '#78716c', fontSize: 12 }}>
              {clientLabel(incident.clientId)}
            </div>
          </div>
        ))}
        {hidden > 0 && <div style={{ color: '#78716c', fontSize: 12 }}>y {hidden} más</div>}
        <Button
          type="link"
          size="small"
          style={{ padding: 0 }}
          onClick={(event) => {
            // Sin esto el clic también dispararía el de la tarjeta (abriría dos veces).
            event.stopPropagation();
            open();
          }}
        >
          Ver incidentes
        </Button>
      </div>
    ),
    duration: NEW_INCIDENT_TOAST_SECONDS,
    placement: 'topRight',
    onClick: open,
    style: { cursor: 'pointer' },
  });
};
